import React from 'react'
import styled from 'styled-components'
import Navbar from '../components/Navbar'
import Announcement from  "../components/Announcement"
import Footer from  "../components/Footer"
import { mobile } from '../responsive'

const Container = styled.div`
`;
const Title = styled.h1`
    margin: 20px;
    font-size: 40px;
    height: 100%
`;
const ImageContainer = styled.div`
    flex: 1;
    height: 50%;
    padding-bottom: 20px;
`
const Image = styled.img`
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 75%;
    height: 100%;
    ${mobile({ width: "90%" })}
`

const Text = styled.div`
    margin-left: 5px;
    margin-right: 5px;
    display: block;
`

const Square = styled.div`
    margin-left: 25px;
    width: 45%;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    vertical-align: top;
    display: inline-block;
    padding: 10px;
    margin-bottom: 20px;
    float: left;
    flex: 1;
`;

const Date = styled.img`
    width: 45%;
    height: 100%;
    float: ;
    margin-left: 60px;
    margin-bottom: 20px;
`
const AdContainer = styled.div`
    
`

const Propane = () => {
  return (
    <Container>
        <Navbar/>
        <Announcement/>
        <Title>Propane Information:</Title>
        <ImageContainer>
            <Image src={"../images/propanetank.JPG"}/>
        </ImageContainer>
        <AdContainer>
            <Square><Text>We refill tanks as long as the tank is within 10 years of the original manufacturing date or 5 years of the recertification date. 
                <br/> <br/>A recertification date is indicated by the letter ‘E’ after the date. If your 20lb tank is out of date, we can exchange your tank for one that is within a valid date range.
                <br/> <br/>If your tank is not 20lbs, we can look at recertifying the tank depending on the condition that the tank is in.
                <br/> <br/> As seen with the tank in the adjacent image, the manufacturing date was 11/98 and the receritification date was 12/11. 
                <br/> <br/> So, the tank orginally expired 10 years after 11/98, which would be 11/08. Then, it was recertified on 12/11 and expired for a second time 5 years later on 12/16.
                </Text></Square>
            <ImageContainer>
                    <Date src={"../images/tankdate.jpeg"}/>
            </ImageContainer>
        </AdContainer>
        <Footer/>
    </Container>
  );
};

export default Propane